module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"no_orders_to_review":"没有可评价的订单。","confirm_cancel_review":"确定要取消评价吗？取消后已输入的内容将全部删除。"}}')
  delete Component.options._Ctor
}
